import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Map, Marker, NavigationControl, Popup } from 'maplibre-gl';

@Component({
  selector: 'app-libremap-view',
  templateUrl: './libremap-view.component.html',
  styleUrls: ['./libremap-view.component.css'],
})
export class LibremapViewComponent implements OnInit, AfterViewInit, OnChanges {
  map!: Map;
  private marker?: Marker;

  @ViewChild('map')
  public mapContainer!: ElementRef<HTMLElement>;
  @Input() draggable: boolean = false;
  @Input() latLong: [number, number] = [0, 0];
  @Output() latLongChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['latLong'] || !this.map || !this.isValidLocation()) return;

    const longLat: [number, number] = [this.latLong[1], this.latLong[0]];
    this.marker?.setLngLat(longLat);
    this.map.flyTo({ center: longLat, zoom: 15 });
  }

  ngAfterViewInit(): void {
    const mapName = 'secretarias-map-open';
    const region = 'sa-east-1';

    const apiKey =
      'v1.public.eyJqdGkiOiI5NTQ4MDFjZS00ODU3LTQ1NjItODU5ZS0wYjVlNGQzYWIyODgifY9gwrIayGKSa7_pE9GkUG_lXyfNwrdVaDpygU8dG5v3aRWoBgTa6K9SSFTW46AjLfaKj9jRXsXgoeA4kUodhp0U35FZjk_9rj6DjC3N6NN7UiQXgYoIRr9VykqFwg1UR03uci9xqpsKmc8KS82oaRVnjWtbRdLGaA1zENLqid3LWQu0jzgd3DnEzSb42TFAPHUIQrikTuBM6lO2rFFYnKP14tZp6R82hY6AkLSxAK9QJa5OWtCuWjxwJoHjD_I4-jgxDi0Gp28l-eV4UCcvauodslnXMNvqvTvM4lv0K09qnTToekudxKw2PWsAp8LfUa2jI_rghP6XfBV8vJNSIc0.ZTA0NDFlODYtNGY5Mi00NWU4LTk1MDgtMmY4YmViYWFhYjUz';

    const longLat: [number, number] = [this.latLong[1], this.latLong[0]];

    this.map = new Map({
      container: this.mapContainer.nativeElement,
      style: `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`,
      center: longLat,
      zoom: 15,
    });

    const popup = new Popup({ offset: 25 });

    const marker = new Marker({ color: 'red', draggable: this.draggable }).setLngLat(longLat).setPopup(popup).addTo(this.map);

    this.marker = marker;

    if (this.draggable) {
      // Evento de término de arrasto
      marker.on('dragend', () => {
        const lngLat = marker.getLngLat();

        this.latLongChange.emit([lngLat.lat, lngLat.lng]);
      });
    }

    this.map.addControl(new NavigationControl(), 'top-right');
  }

  private isValidLocation(): boolean {
    return Number(this.latLong[0]) !== 0 && Number(this.latLong[1]) !== 0;
  }

  ngOnDestroy() {
    this.map?.remove();
  }
}
